<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="avatar-cropper">
      <div v-if="!imageUrl" class="upload-section">
        <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :http-request="handleUpload"
          :auto-upload="true"
          accept="image/*"
        >
          <div class="upload-placeholder">
            <i class="el-icon-plus"></i>
            <div class="upload-text">点击上传图片</div>
          </div>
        </el-upload>
      </div>
      <div v-else class="cropper-wrapper">
        <div class="cropper-section">
          <div class="cropper-container">
            <vue-cropper
              ref="cropper"
              :img="imageUrl"
              :outputSize="1"
              :outputType="'png'"
              :info="true"
              :full="false"
              :canMove="true"
              :canMoveBox="true"
              :canScale="true"
              :autoCrop="true"
              :autoCropWidth="200"
              :autoCropHeight="200"
              :fixed="true"
              :fixedNumber="[1, 1]"
              :fixedBox="false"
              :original="false"
              :centerBox="true"
              :high="true"
              :infoTrue="false"
              :mode="'contain'"
              :maxImgSize="2000"
              @realTime="realTime"
            ></vue-cropper>
          </div>
          <div class="controls">
            <div class="control-row">
              <el-button-group>
                <el-button size="small" @click="changeScale(1)">放大</el-button>
                <el-button size="small" @click="changeScale(-1)">缩小</el-button>
              </el-button-group>
              <el-button-group>
                <el-button size="small" @click="rotateLeft">左旋转</el-button>
                <el-button size="small" @click="rotateRight">右旋转</el-button>
              </el-button-group>
              <el-button size="small" @click="resetCrop">重置</el-button>
            </div>
          </div>
        </div>
        <div class="preview-section">
          <div class="preview-label">预览效果：</div>
          <div class="preview-item">
            <div class="preview-title">大头像 (120x120)</div>
            <div class="avatar-preview avatar-preview-lg">
              <img :src="previews.url" />
            </div>
          </div>
          <div class="preview-item">
            <div class="preview-title">中头像 (80x80)</div>
            <div class="avatar-preview avatar-preview-md">
              <img :src="previews.url" />
            </div>
          </div>
          <div class="preview-item">
            <div class="preview-title">小头像 (40x40)</div>
            <div class="avatar-preview avatar-preview-sm">
              <img :src="previews.url" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'AvatarCropper',
  components: {
    VueCropper
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '裁剪头像'
    }
  },
  data() {
    return {
      dialogVisible: false,
      imageUrl: '',
      loading: false,
      previews: {}
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.reset()
      }
    }
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },
    handleUpload({ file }) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    realTime(data) {
      this.previews = data
    },
    changeScale(num) {
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    resetCrop() {
      this.$refs.cropper.reset()
    },
    reset() {
      this.imageUrl = ''
      this.previews = {}
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleConfirm() {
      if (!this.imageUrl) {
        this.$message.warning('请先上传图片')
        return
      }
      
      this.loading = true
      
      this.$refs.cropper.getCropBlob((blob) => {
        try {
          this.$emit('confirm', blob)
          this.dialogVisible = false
        } catch (error) {
          console.error(error)
          this.$message.error('裁剪失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.avatar-cropper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-section {
  text-align: center;
  padding: 40px 0;
}

.avatar-uploader {
  display: inline-block;
}

.upload-placeholder {
  width: 200px;
  height: 200px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  transition: border-color 0.3s;
}

.upload-placeholder:hover {
  border-color: #409EFF;
}

.upload-placeholder .el-icon-plus {
  font-size: 40px;
  margin-bottom: 10px;
}

.upload-text {
  font-size: 14px;
}

.cropper-wrapper {
  display: flex;
  gap: 30px;
}

.cropper-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.cropper-container {
  height: 400px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

.controls {
  display: flex;
  justify-content: center;
}

.control-row {
  display: flex;
  gap: 10px;
}

.preview-section {
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.preview-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  text-align: center;
}

.preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.preview-title {
  font-size: 12px;
  color: #909399;
}

.avatar-preview {
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e4e7ed;
}

.avatar-preview img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-preview-lg {
  width: 120px;
  height: 120px;
}

.avatar-preview-md {
  width: 80px;
  height: 80px;
}

.avatar-preview-sm {
  width: 40px;
  height: 40px;
}
</style>
